import { useTheme } from '../../../auth/ThemeContext';

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();

  return (
    <button onClick={toggle}
      className="flex items-center gap-2 px-3 py-2 rounded-xl border-2 transition-all cursor-pointer whitespace-nowrap bg-rose-50 border-rose-100 text-rose-500 hover:bg-rose-100 dark:bg-slate-700 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-600">
      <i className={`${theme === 'dark' ? 'ri-sun-line' : 'ri-moon-line'} text-sm`}></i>
      <span className="text-xs font-semibold">{theme === 'dark' ? 'בהיר' : 'כהה'}</span>
    </button>
  );
}
